import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {},
};

const uploadFileSlice = createSlice({
  name: "uploadFileRecruitment",
  initialState,
  reducers: {
    uploadFileStart: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.LOADING;
    },
    uploadFileSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    uploadFileFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const { uploadFileStart, uploadFileSuccess, uploadFileFailed } =
  uploadFileSlice.actions;

export default uploadFileSlice.reducer;
